import {
    Card,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableRow,
} from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2"; // Grid version 2
import { useState, useEffect } from "react";
import { useClient } from "../../../context/ClientProvider";
import { formatCurrency } from '../../../utils/formatCurrency';

function createData(id, title, value) {
    return { id, title, value };
}

function AboutMyLoanCard({ accountNumber, loanStartDate, loanEndDate, agreedLoanAmount, currentLoanBalance }) {
    const [ localPalette, setLocalPalette ] = useState(null);
    const { useGetConfig } = useClient();
    const { clientConfig } = useGetConfig();
    useEffect(() => {
        if (clientConfig && clientConfig?.theme?.palette) {
          setLocalPalette(clientConfig.theme.palette);
        }
      }, [clientConfig]);
    let cardData = [
        createData(
            "account-number",
            "Account number: ",
            accountNumber
        ),
        createData(
            "loan-start-date",
            "Loan start date: ",
            loanStartDate
        ),
        createData(
            "loan-end-date",
            "Loan end date: ",
            loanEndDate
        ),
        createData(
            "agreed-loan-amount",
            "Agreed loan amount: ",
            formatCurrency(agreedLoanAmount)
        ),
        createData(
            "current-loan-balance",
            "Current loan balance: ",
            formatCurrency(currentLoanBalance)
        ),
    ]
    return localPalette && (
        <Grid>
            <Card
                id="balance-container"
                sx={{
                    textAlign: "left",
                    backgroundColor: "primary.dark",
                    color: "primary.contrastText",
                    borderRadius: 0,
                    borderLeft: `10px solid ${localPalette.secondary.dark}`
                }}>
                <Typography
                    id="balance-label"
                    fontWeight={"bold"}
                    fontSize={24}
                    paddingTop={1}
                    marginLeft={2}
                >
                    About my loan
                </Typography>
                <TableContainer sx={{ py: 1, px: 1}}>
                    <Table
                        sx={{ minWidth: "100%" }}
                        size='small'
                        aria-label='repayment plan table'
                    >
                        <TableBody>
                            {cardData.map((row) => (
                                <TableRow
                                    key={row.title}
                                    sx={{
                                        "td, th": { border: 0 },
                                        th: { color: "#FFF" },
                                        td: { color: "#FFF" },
                                    }}
                                >
                                    <TableCell
                                        sx={{ fontWeight: "bold" }}
                                        component='th'
                                        scope='row'
                                    >
                                        {row.title}
                                    </TableCell>
                                    <TableCell id={row.id} align='right'>
                                        {row.value}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Card>
        </Grid>
    )
}

export default AboutMyLoanCard;